import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

import HeaderPage from "../../components/HeaderPage";
import HexagonComponent from "../../components/HexagonComponent";
import styles from "./ResetPasswordPage.module.css";
import ResetPasswordBlock2 from "../../components/ResetPasswordBlock2";
import ResetPasswordBlock1 from "../../components/ResetPasswordBlock1";
import ResetPasswordBlock3 from "../../components/ResetPasswordBlock3";

export default function () {
    const location = useLocation()

    const [step, setStep] = useState(1)

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search)
        const stepParam = urlParams.get("s")
        if(stepParam)
            setStep(parseInt(stepParam))
    }, [location])

    return (
        <div className={`container-fluid ${styles.page}`}>
            <HeaderPage />
            <div className={`row my-5 ${styles.resetpasswordComponent}`}>
                <div
                    className={`col-lg-4 col-xl-4 col-md-6 col-sm-4 ${styles.hexagonlogoContainer}`}
                >
                    <HexagonComponent />
                </div>
                <div
                    className={`col-lg-4 col-xl-3 col-md-6 col-sm-3 ${styles.resetpasswordContainer}`}
                >
                    {step === 1
                        ? <ResetPasswordBlock1 />
                        : (step === 2
                            ? <ResetPasswordBlock2 />
                            : <ResetPasswordBlock3 />
                        )
                    }
                </div>
            </div>
        </div>
    );
}
